import './Input.css';

const Input = ({ 
  label, 
  error, 
  className = '', 
  required,
  size = 'md',
  iconLeft,
  iconRight,
  ...props 
}) => {
  const groupClasses = [
    'input-group',
    `input-${size}`,
    error && 'error',
    className
  ].filter(Boolean).join(' ');

  const wrapperClasses = [
    'input-wrapper',
    iconLeft && 'has-icon-left',
    iconRight && 'has-icon-right'
  ].filter(Boolean).join(' ');

  return (
    <div className={groupClasses}>
      {label && (
        <label className="input-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <div className={wrapperClasses}>
        {iconLeft && <span className="input-icon input-icon-left">{iconLeft}</span>}
        <input className="input" required={required} {...props} />
        {iconRight && <span className="input-icon input-icon-right">{iconRight}</span>}
      </div>
      {error && <span className="input-error">{error}</span>}
    </div>
  );
};

export default Input;
